<template>
  <el-header class="tk-header">
    <div class="tk-header-inner">
      <img :src="require('@/assets/img/logo2.jpg')" class="tk-logo" loading="eager" />
      <el-menu
        v-show="!isMobile"
        :default-active="activeIndex"
        class="tk-nav"
        mode="horizontal"
        @select="handleMenuSelect"
      >
        <el-menu-item index="/">首页</el-menu-item>
<!--        <el-menu-item index="/service">多肽服务</el-menu-item>-->
        <el-menu-item index="/product">产品中心</el-menu-item>
        <el-menu-item index="/support">技术支持</el-menu-item>
        <el-menu-item index="/order">产品订购</el-menu-item>
        <el-menu-item index="/about">关于我们</el-menu-item>
      </el-menu>
      <div class="tk-search" v-show="!isMobile">
<!--        <el-input placeholder="请输入标题/关键词" v-model="searchKey" size="small" class="tk-search-input">-->
<!--          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>-->
<!--        </el-input>-->
      </div>
      <!-- 汉堡按钮 -->
      <div class="mobile-menu-btn" v-show="isMobile" @click="drawer = true">
        <i class="el-icon-menu"></i>
      </div>
      <!-- Drawer 菜单 -->
      <el-drawer
        title="菜单"
        :visible.sync="drawer"
        direction="ltr"
        size="70%"
        :with-header="false"
        custom-class="mobile-drawer"
      >
        <el-menu
          :default-active="activeIndex"
          class="mobile-nav"
          mode="vertical"
          @select="handleMenuSelect"
        >
          <el-menu-item index="/">首页</el-menu-item>
<!--          <el-menu-item index="/service">多肽服务</el-menu-item>-->
          <el-menu-item index="/product">产品中心</el-menu-item>
          <el-menu-item index="/support">技术支持</el-menu-item>
          <el-menu-item index="/order">产品订购</el-menu-item>
          <el-menu-item index="/about">关于我们</el-menu-item>
        </el-menu>
        <div style="padding: 16px;">
<!--          <el-input placeholder="请输入标题/关键词" v-model="searchKey" size="small" class="tk-search-input">-->
<!--            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>-->
<!--          </el-input>-->
        </div>
      </el-drawer>
    </div>
  </el-header>
</template>

<script>
export default {
  name: 'NavHeader',
  data() {
    return {
      activeIndex: this.$route.path,
      searchKey: '',
      drawer: false,
      isMobile: false
    }
  },
  methods: {
    handleMenuSelect(key) {
      this.drawer = false;
      if (this.$route.path !== key) {
        this.$router.push(key);
      }
    },
    handleSearch() {
      // 搜索逻辑
      console.log('搜索关键词:', this.searchKey);
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    }
  },
  mounted() {
    this.activeIndex = this.$route.path || '/';
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  watch: {
    '$route.path': {
      handler(newPath) {
        this.activeIndex = newPath;
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.tk-header {
  background: #fff;
  box-shadow: 0 2px 8px #f0f1f2;
  padding: 0 40px;
  display: flex;
  align-items: center;
  height: 80px;
}
.tk-header-inner {
  display: flex;
  align-items: center;
  width: 100%;
}
.tk-logo {
  height: 60px;
  margin-right: 30px;
}
.tk-nav {
  flex: 1;
}
.tk-search {
  margin-left: 30px;
}
.tk-search-input {
  width: 220px;
}
.mobile-menu-btn {
  display: none;
  font-size: 28px;
  cursor: pointer;
  margin-left: auto;
}
@media (max-width: 768px) {
  .tk-header {
    padding: 0 8px;
    height: 56px;
  }
  .tk-logo {
    height: 36px;
    margin-right: 10px;
  }
  .mobile-menu-btn {
    display: block;
  }
}
.mobile-drawer .el-drawer__body {
  padding: 0;
}
.mobile-nav {
  border-right: none;
}
</style>

<style>
@media (max-width: 768px) {
  .tk-header {
    padding: 0 8px;
    height: 56px;
  }
  .tk-header-inner {
    flex-direction: row;
    padding: 0;
  }
  .tk-logo {
    height: 36px;
    margin-right: 10px;
  }
  .tk-nav {
    font-size: 13px;
  }
  .tk-search {
    margin-left: 8px;
  }
  .tk-search-input {
    width: 120px;
  }
  .el-menu--horizontal > .el-menu-item, .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 40px !important;
    line-height: 40px !important;
    padding: 0 8px !important;
    font-size: 13px !important;
  }
  .el-header {
    min-width: 0 !important;
  }
}
</style>
